import React from "react";
import { TotoAdaptiveDock } from "./TotoAdaptiveSurface";
import "@/styles/scheduling-vessel.css";

/** Shared presentation shell; each scheduling page retains its own task logic. */
export default function SchedulingVessel({ title, description, children }) {
  return (
    <main className="toto-workspaces scheduling-vessel">
      <section className="toto-workspaces__vessel scheduling-vessel__surface" aria-labelledby="scheduling-heading">
        <header className="scheduling-vessel__header">
          <h1 id="scheduling-heading">{title}</h1>
          {description && <p>{description}</p>}
        </header>
        <div className="scheduling-vessel__content" role="region" aria-label={title} tabIndex={0}>
          {children}
        </div>
      </section>
      <TotoAdaptiveDock active="workspace" />
    </main>
  );
}
